//* Styles
import PortfolioListSkeletonStyle from './style';

//* SVG
import { portfolioSkeleton1, portfolioSkeleton2 } from './svg';

const PortfolioListSkeleton = () => {
	const fakeItem = Array.from({ length: 6 }, (_, index) => {
		return (
			<div
				key={index}
				className={`portfolio-skeleton-block`}>
				{index === 1 || index === 4 ? portfolioSkeleton2 : portfolioSkeleton1}
			</div>
		);
	});

	return <PortfolioListSkeletonStyle>{fakeItem}</PortfolioListSkeletonStyle>;
};

export default PortfolioListSkeleton;
